module.exports = __webpack_public_path__ + "img/AWWA.af347f25.png";